import React from 'react'
import "./agent.css";
import { team } from '../data/Data';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import Button from '@mui/material/Button';
import EmailIcon from '@mui/icons-material/Email';
import CallIcon from '@mui/icons-material/Call';
function agent() {
    return (
        <section className='paddings flexDisplay agentSection'>
            <h1 className='primaryText'>Our Featured Agents</h1>
            <span className="secondaryText">Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor<br />
                incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam.</span>

            <div className="containerMembers">
                {team.map((item, index) => (
                    <div className='onlyMembers' key={index}>
                        <span className='headerContent flex gap-2'>{item.list} <span className='font-normal'>listings</span></span>
                       <div className="imageContainer">
                         <img src={item.cover} alt={item.name} />
                       </div>
                        <span className='secondaryText'>
                            <LocationOnIcon/>{item.address}
                        </span>
                        <h1>{item.name}</h1>
                        <div className="socialmedia">
                            {item.icon}
                        </div>
                        <div className="southContent">
                                  <Button variant="contained" ><EmailIcon/> Message</Button>
                                        <Button variant="contained"><CallIcon/></Button>
                        </div>
                    </div>
                ))}
            </div>
        </section>
    )
}

export default agent
